'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        messagesAllDay: {
            type: String,
            default: undefined,
            kComposite: 'messages.allDay'
        },
        messagesAriaEventLabel: {
            type: String,
            default: undefined,
            kComposite: 'messages.ariaEventLabel'
        },
        messagesAriaSlotLabel: {
            type: String,
            default: undefined,
            kComposite: 'messages.ariaSlotLabel'
        },
        messagesCancel: {
            type: String,
            default: undefined,
            kComposite: 'messages.cancel'
        },
        messagesDate: {
            type: String,
            default: undefined,
            kComposite: 'messages.date'
        },
        messagesDeleteWindowTitle: {
            type: String,
            default: undefined,
            kComposite: 'messages.deleteWindowTitle'
        },
        messagesDestroy: {
            type: String,
            default: undefined,
            kComposite: 'messages.destroy'
        },
        messagesEvent: {
            type: String,
            default: undefined,
            kComposite: 'messages.event'
        },
        messagesDefaultRowText: {
            type: String,
            default: undefined,
            kComposite: 'messages.defaultRowText'
        },
        messagesNext: {
            type: String,
            default: undefined,
            kComposite: 'messages.next'
        },
        messagesPdf: {
            type: String,
            default: undefined,
            kComposite: 'messages.pdf'
        },
        messagesPrevious: {
            type: String,
            default: undefined,
            kComposite: 'messages.previous'
        },
        messagesSave: {
            type: String,
            default: undefined,
            kComposite: 'messages.save'
        },
        messagesShowFullDay: {
            type: String,
            default: undefined,
            kComposite: 'messages.showFullDay'
        },
        messagesShowWorkDay: {
            type: String,
            default: undefined,
            kComposite: 'messages.showWorkDay'
        },
        messagesTime: {
            type: String,
            default: undefined,
            kComposite: 'messages.time'
        },
        messagesToday: {
            type: String,
            default: undefined,
            kComposite: 'messages.today'
        },
        messagesEditableConfirmation: {
            type: String,
            default: undefined,
            kComposite: 'messages.editable.confirmation'
        },
        messagesEditorAllDayEvent: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.allDayEvent'
        },
        messagesEditorDescription: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.description'
        },
        messagesEditorEditorTitle: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.editorTitle'
        },
        messagesEditorEnd: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.end'
        },
        messagesEditorEndTimezone: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.endTimezone'
        },
        messagesEditorRepeat: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.repeat'
        },
        messagesEditorSeparateTimezones: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.separateTimezones'
        },
        messagesEditorStart: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.start'
        },
        messagesEditorStartTimezone: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.startTimezone'
        },
        messagesEditorTimezone: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.timezone'
        },
        messagesEditorTimezoneEditorButton: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.timezoneEditorButton'
        },
        messagesEditorTimezoneEditorTitle: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.timezoneEditorTitle'
        },
        messagesEditorTitle: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.title'
        },
        messagesRecurrenceEditorDailyInterval: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.daily.interval'
        },
        messagesRecurrenceEditorDailyRepeatEvery: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.daily.repeatEvery'
        },
        messagesRecurrenceEditorEndAfter: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.end.after'
        },
        messagesRecurrenceEditorEndOccurrence: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.end.occurrence'
        },
        messagesRecurrenceEditorEndLabel: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.end.label'
        },
        messagesRecurrenceEditorEndNever: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.end.never'
        },
        messagesRecurrenceEditorEndMobileLabel: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.end.mobileLabel'
        },
        messagesRecurrenceEditorEndOn: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.end.on'
        },
        messagesRecurrenceEditorFrequenciesDaily: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.frequencies.daily'
        },
        messagesRecurrenceEditorFrequenciesMonthly: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.frequencies.monthly'
        },
        messagesRecurrenceEditorFrequenciesNever: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.frequencies.never'
        },
        messagesRecurrenceEditorFrequenciesWeekly: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.frequencies.weekly'
        },
        messagesRecurrenceEditorFrequenciesYearly: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.frequencies.yearly'
        },
        messagesRecurrenceEditorMonthlyDay: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.monthly.day'
        },
        messagesRecurrenceEditorMonthlyInterval: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.monthly.interval'
        },
        messagesRecurrenceEditorMonthlyRepeatEvery: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.monthly.repeatEvery'
        },
        messagesRecurrenceEditorMonthlyRepeatOn: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.monthly.repeatOn'
        },
        messagesRecurrenceEditorOffsetPositionsFirst: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.offsetPositions.first'
        },
        messagesRecurrenceEditorOffsetPositionsSecond: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.offsetPositions.second'
        },
        messagesRecurrenceEditorOffsetPositionsThird: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.offsetPositions.third'
        },
        messagesRecurrenceEditorOffsetPositionsFourth: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.offsetPositions.fourth'
        },
        messagesRecurrenceEditorOffsetPositionsLast: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.offsetPositions.last'
        },
        messagesRecurrenceEditorRecurrenceEditorTitle: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.recurrenceEditorTitle'
        },
        messagesRecurrenceEditorWeeklyInterval: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.weekly.interval'
        },
        messagesRecurrenceEditorWeeklyRepeatEvery: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.weekly.repeatEvery'
        },
        messagesRecurrenceEditorWeeklyRepeatOn: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.weekly.repeatOn'
        },
        messagesRecurrenceEditorWeekdaysDay: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.weekdays.day'
        },
        messagesRecurrenceEditorWeekdaysWeekday: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.weekdays.weekday'
        },
        messagesRecurrenceEditorWeekdaysWeekend: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.weekdays.weekend'
        },
        messagesRecurrenceEditorYearlyOf: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.yearly.of'
        },
        messagesRecurrenceEditorYearlyRepeatEvery: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.yearly.repeatEvery'
        },
        messagesRecurrenceEditorYearlyRepeatOn: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.yearly.repeatOn'
        },
        messagesRecurrenceEditorYearlyInterval: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.yearly.interval'
        },
        messagesRecurrenceMessagesDeleteRecurring: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceMessages.deleteRecurring'
        },
        messagesRecurrenceMessagesDeleteWindowOccurrence: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceMessages.deleteWindowOccurrence'
        },
        messagesRecurrenceMessagesDeleteWindowSeries: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceMessages.deleteWindowSeries'
        },
        messagesRecurrenceMessagesDeleteWindowTitle: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceMessages.deleteWindowTitle'
        },
        messagesRecurrenceMessagesEditRecurring: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceMessages.editRecurring'
        },
        messagesRecurrenceMessagesEditWindowOccurrence: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceMessages.editWindowOccurrence'
        },
        messagesRecurrenceMessagesEditWindowSeries: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceMessages.editWindowSeries'
        },
        messagesRecurrenceMessagesEditWindowTitle: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceMessages.editWindowTitle'
        },
        messagesViewsDay: {
            type: String,
            default: undefined,
            kComposite: 'messages.views.day'
        },
        messagesViewsWeek: {
            type: String,
            default: undefined,
            kComposite: 'messages.views.week'
        },
        messagesViewsMonth: {
            type: String,
            default: undefined,
            kComposite: 'messages.views.month'
        },
        messagesViewsAgenda: {
            type: String,
            default: undefined,
            kComposite: 'messages.views.agenda'
        }
    }
};